import { UnmatchedOrderInfo } from '@/coreInfrastructureModule/axios/generated/unmatchedOrderManage';
import { UnmatchedOrderItem } from '../domains/entities/UnmatchedOrderItem';

/**
 * APIレスポンスをUI表示用のUnmatchedOrderItemに変換する
 */
export class GetUnmatchedOrdersAdapter {
  /**
   * UnmatchedOrderInfoの配列をUnmatchedOrderItemの配列に変換する
   * @param orders - APIレスポンスの未照合データ
   * @returns UI表示用の未照合データ
   */
  public static adapt(orders: UnmatchedOrderInfo[]): UnmatchedOrderItem[] {
    return orders.map((order) => ({
      unmatchedOrderId: order.unmatchedOrderId,
      warehouseNumber: order.warehouseNumber,
      warehouse: order.warehouse,
      supplierNumber: order.supplierNumber,
      supplierName: order.supplierName,
      businessNumber: order.businessNumber,
      businessName: order.businessName,
      package: Number(order.package),
      createdOrderDate: order.createdOrderDate ?? undefined,
      desiredDeliveryDate: order.desiredDeliveryDate ?? undefined,
      estimatedTimeOfArrival: order.estimatedTimeOfArrival ?? undefined,
      orderIssuedNumber: order.orderIssuedNumber ?? undefined,
      orderNumber: order.orderNumber ?? undefined,
      orderAmount: order.orderAmount ? Number(order.orderAmount) : undefined,
      orderStatus: order.orderStatus ?? undefined,
      errorReason: order.errorReason,
      unmatchedOrderStatus: order.unmatchedOrderStatus,
      matchedOrderId: order.matchedOrderId ?? null,
    }));
  }
}
